import React, { useEffect, useState, useMemo } from "react";
import { Outlet, Link } from "react-router-dom";
import { Form, Button } from 'react-bootstrap';
import Badge from 'react-bootstrap/Badge';
import Loader from '../../component/loader';
import { BiCategory, BiFilterAlt } from "react-icons/bi";
import { FiChevronLeft as ChevronLeft, FiChevronRight as ChevronRight } from "react-icons/fi";
import { Modal } from "react-bootstrap";
import Cookies from "js-cookie";
import { decrpt } from "../../component/encryption";
import axios from "axios";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

function BrandMap() {  
  const [loader,setLoader] = useState(false)
  const [show,setShow] = useState(false)
  const [dshow,setDShow] = useState(false)
  const [deleteItem, setDeleteItem] = useState(null);
  const [Eshow,setEShow] = useState(false);
  const [errors , setErrors] = useState();
  const [toastText, setToastText] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [searchText, setSearchText] = useState("");
  const [lastCategory, setLastCategory] = useState();
  const [newLastCategory, setNewLastCategory] = useState();
  const [brandList, setBrandList] = useState();
  const [brandListfetch, setBrandListfetch] = useState();
  const [statusShow, setStatusShow] = useState();
  const [newUpdateStatus, setNewUpdateStatus] = useState();
  const [category, setCategory] = useState();
  const [subCategory, setSubCategory] = useState();
  const [disabled, setDisabled] = useState(true);

  const [selectedCategoryId, setSelectedCategoryId] = useState('');
  const [selectedSubCategoryId, setSelectedSubCategoryId] = useState('');
  const [selectedThirdCategoryId, setSelectedThirdCategoryId] = useState('');

  const [newBrand, setNewBrand] = useState();
  const [newBrandPreview, setNewBrandPreview] = useState();
  const [brandMapList, setBrandMapList] = useState([]);

  // Filtered brand maps by search
  const filteredBrandMaps = useMemo(() => {
    if (!Array.isArray(brandMapList)) return [];
    if (!searchText.trim()) return brandMapList;
    const q = searchText.trim().toLowerCase();
    return brandMapList.filter((item) => {
      const brand = (item.brand || "").toLowerCase();
      const cat = (item.category || "").toLowerCase();
      const subCat = (item.sub_category || "").toLowerCase();
      const lastCat = (item.last_category || "").toLowerCase();
      const id = String(item.id || "").toLowerCase();
      return brand.includes(q) || cat.includes(q) || subCat.includes(q) || lastCat.includes(q) || id.includes(q);
    });
  }, [brandMapList, searchText]);

  // Pagination logic
  const totalItems = filteredBrandMaps.length;
  const totalPages = Math.max(1, Math.ceil(totalItems / itemsPerPage));

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [totalPages, currentPage]);

  const paginatedBrandMaps = useMemo(() => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return filteredBrandMaps.slice(startIndex, endIndex);
  }, [filteredBrandMaps, currentPage, itemsPerPage]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const handleItemsPerPageChange = (e) => {
    setItemsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };
  const [editBrand , setEditBrand ] = useState({
    name : '',
    category_id : '',
    sub_category_id: '',
    third_category_id: '',
    size_chart : '',
    brand_id : ''
  });
// console.log(newBrand  , 'newSize upload check');
console.log(brandMapList , 'newLastCategory ');
  const handleOpen = () => {
    setShow(true);
    setSelectedCategoryId('');
    setSelectedSubCategoryId('');
    setSelectedThirdCategoryId('');
    setNewBrand({});
    setDisabled(false);
    getCategoryList();
    setErrors(false);
  };
  const handleClose = () => {
    setShow(false);
  };

  const handleCloseDelete = () => {
    setDShow(false);
    setDeleteItem(null);
  };

  const handleDelete = (item) => {
    setDeleteItem(item);
    setDShow(true);
  };

  const confirmDeleteBrandMap = async () => {
    if (!deleteItem) return;
    setLoader(true);
    try {
      const token = Cookies.get('s_l');
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/master/brand/map/delete`, { id: deleteItem.id });
      if (response.data.success) {
        setBrandMapList(prev => prev.filter(m => m.id !== deleteItem.id));
        setToastText("Brand Map Deleted Successfully");
        toast.success("Brand Map Deleted Successfully", { hideProgressBar: true });
      }
    } catch (err) {
      console.error(err);
      toast.error(err.response?.data?.message || "Failed to delete Brand Map", { hideProgressBar: true });
    } finally {
      setDShow(false);
      setDeleteItem(null);
      setLoader(false);
    }
  };

  const editCall = async (item) => {
    console.log(item, 'item check');
    setLoader(true);
    try {
      const catId = item.category_id || item.main_category_id || '';
      const subCatId = item.sub_category_id || '';
      const thirdCatId = item.third_category_id || '';

      setEditBrand({
        id: item.id,
        category_id : catId,
        sub_category_id: subCatId,
        third_category_id: thirdCatId,
        brand_id    : item.brand_id || ''
      });

      if (!category || category.length === 0) {
        await getCategoryList();
      }
      if (catId) {
        await getSubCategoryList(catId);
      } else {
        setSubCategory([]);
      }
      if (subCatId) {
        await getLastCategoryList(subCatId);
      } else {
        setLastCategory([]);
      }
      setEShow(true);
    } catch (err) {
      console.error(err);
    } finally {
      setLoader(false);
    }
  };
// console.log(newBrand , 'check new brand');
  const handleCloseEdit = () => {
    setEShow(false);
  };

  function handleChartPreview(e) {
    setNewBrandPreview({...newBrandPreview , size_chart:URL.createObjectURL(e.target.files[0])});
    setNewBrand({...newBrand, size_chart:e.target.files[0]});
    }
  function handleEditChartPreview(e) {
    setNewBrandPreview({...newBrandPreview , size_chart:URL.createObjectURL(e.target.files[0])});
    setEditBrand({...editBrand, size_chart:e.target.files[0]});
    }

    const handleCategory = (category_id) => {
      setSelectedCategoryId(category_id);
      setSelectedSubCategoryId('');
      setSelectedThirdCategoryId('');
      setSubCategory([]);
      setLastCategory([]);
      getSubCategoryList(category_id);
    }
    
    const handleSubCategory = (sub_category_id) => {
      setSelectedSubCategoryId(sub_category_id);
      setSelectedThirdCategoryId('');
      setLastCategory([]);
      getLastCategoryList(sub_category_id);
    }

    const handleThirdCategory = (third_category_id) => {
      setSelectedThirdCategoryId(third_category_id);
    }
// status
const handleStatus = (item)=> {
  setStatusShow(true);
  setNewUpdateStatus(item);
}
const handleStatusClose = () =>{
  setStatusShow(false);
}
// sttaus

// fetch first category
const getCategoryList = async() => {
  try {
    const token = Cookies.get('s_l');  
    const newToken = decrpt(token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
    const response = await axios.post(`admin/category/list`, {type:1})
    setCategory(response.data.data.list)
  } catch (error) {
    console.error(error);
  }
}
// fetch first category


// fetch second category
const getSubCategoryList = async(category_id ) => {
  const data = {
    type : 2,
    category_id : category_id
  }
  try {
    const token = Cookies.get('s_l');  
    const newToken = decrpt(token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
    const response = await axios.post(`admin/category/dropdown/list`, data)
    console.log(response.data.data , ' fetch second cat with respct first');
    setSubCategory(response.data.data);
  } catch (error) {
    console.error(error);
  }
}

const getLastCategoryList = async(category_id) => {
  try {
  const data = {
    type : 3 ,
    category_id : category_id
  }
  console.log(category_id ,'sub_category_id');
    const token = Cookies.get('s_l');  
    const newToken = decrpt(token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
    const response = await axios.post(`admin/category/dropdown/list`, data)
    console.log('Last Level',response.data);
    setDisabled(false);
    setLastCategory(response.data.data)
  } catch (error) {
    console.error(error);
  }
}
// fetch last category
// fetch brandFetch
const fetchbrandList = async () => {
    setLoader(true);
    const token = Cookies.get('s_l');  
    const newToken = decrpt(token);
    axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
    const response = await axios.post(`/admin/master/brand/list` )
    .then((response) => {
      setBrandListfetch(response.data.data.list);
      setLoader(false);
    }).catch((err) => {
      console.log('seller list error' , err.response)
      setLoader(false);
    })
  }
// fetch brandFetch

// add brandmap
const addBrandMap = async() => {
  setLoader(true);
  try {
        const formData = new FormData();
        formData.append("category_id", selectedCategoryId || "");
        if (selectedSubCategoryId) {
            formData.append("sub_category_id", selectedSubCategoryId);
        }
        if (selectedThirdCategoryId) {
            formData.append("third_category_id", selectedThirdCategoryId);
        }
        formData.append("brand_id", newBrand?.brand_id || "");
      const token = Cookies.get('s_l');  
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
      const response = await axios.post(`/admin/master/brand/map/save`, formData)
      .then((response)=>{
          handleClose();
          fetchBrandMapList();
          setLoader(false);
          setToastText("Brand Map Added");
          toast.success("Brand Map Added Successfully", {hideProgressBar:true});
      }).catch((err)=>{
        console.error('Error',err);
        setToastText("Something went wrong")
        toast.danger(toastText,{hideProgressBar:true})
        setErrors('Please Fill all the inputs');
        setEShow(false);
        setLoader(false);
      })
    } catch (error) {
      console.log(error , 'eooror');
      setEShow(false);
      setLoader(false);
      if(error.response.status == 412){
        setErrors(error.response.data.message);
      }else {
        setErrors('please fill all the Inputs')
      }
    }
  }
// add brand map
// update brandmap
const updateBrandMap = async() => {
    setLoader(true);
    const formData = new FormData();
    formData.append("id", editBrand.id);
    formData.append("category_id", editBrand.category_id || "");
    if (editBrand.sub_category_id) {
        formData.append("sub_category_id", editBrand.sub_category_id);
    }
    if (editBrand.third_category_id) {
        formData.append("third_category_id", editBrand.third_category_id);
    }
    formData.append("brand_id", editBrand.brand_id || "");
    try {
      const token = Cookies.get('s_l');  
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/master/brand/map/save`, formData);
      if(response.data.success){
        setEShow(false);
        fetchBrandMapList();
        setToastText("Updated Brand Map");
        toast.success("Brand Map Updated Successfully", {hideProgressBar:true});
      }
    } catch (err) {
      console.error('Error', err);
      toast.error(err.response?.data?.message || "Something went wrong", {hideProgressBar:true});
      setLoader(false);
    }
}

// update brand map

  const fetchBrandMapList = async () => {
    setLoader(true);
    const data = {
        status : 'all'
    };
    try {
      const token = Cookies.get('s_l');  
      const newToken = decrpt(token);
      axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;
      const response = await axios.post(`/admin/master/brand/map/list`, data);
      if (response.data?.success && response.data?.data) {
        let list = response.data.data.list || [];
        const pagination = response.data.data.pagination;
        if (pagination && pagination.total_pages > 1 && list.length < pagination.total_data) {
          const pagePromises = [];
          for (let p = 2; p <= pagination.total_pages; p++) {
            pagePromises.push(axios.post(`/admin/master/brand/map/list?page=${p}`, data));
          }
          const extraResponses = await Promise.all(pagePromises);
          extraResponses.forEach(res => {
            if (res.data?.success && res.data?.data?.list) {
              list = list.concat(res.data.data.list);
            }
          });
        }
        setBrandMapList(list);
      }
    } catch (err) {
      console.log('brand map list error' , err.response);
    } finally {
      setLoader(false);
    }
  }
// status of brand map

const statusBrandMap = async()=> {
    setLoader(true);
    let newstatus = '';
    if (newUpdateStatus.status == 1) {
      newstatus = 2;
    } else  {
      newstatus = 1;
    }
    const data = {
      id: newUpdateStatus.id,
      status : newstatus
    }
    try {
        const token = Cookies.get('s_l');
        const newToken = decrpt(token);
        axios.defaults.headers.common['Authorization'] = `Bearer ${newToken}`
        const response = await axios.post(`/admin/master/brand/map/status`, data ).then((response) => {
          console.log('Response',response);
          let tmparray = brandMapList;
          let obj = tmparray.find((o, i) => {
            if (o.id === newUpdateStatus.id) {
                tmparray[i] = {...brandMapList[i] ,   status : newstatus  };
                return true; 
              }
            });
            setToastText("Brand Map Status Updated")
            toast.success(toastText,{hideProgressBar:true})
            setLoader(false);
            setStatusShow(false);
        })
    }catch(error) {
        console.log(error);
        setToastText("Something went wrong")
        toast.success(toastText,{hideProgressBar:true})
        setLoader(false);
    }
  }
// status of brand map

  useEffect (() => {
    window.scrollTo(0, 0);
    setLoader(true);
    getCategoryList();
    fetchBrandMapList();
    setTimeout(async() => {
        // await getLastCategoryList(); 
        await fetchbrandList();     
      setLoader(false);
    }, 500);
  }, []);

  // useEffect(() =>{

  // })

  return (
    <div className="main-content">
      {loader ? 
        <Loader />
        :
        <>
      <ToastContainer position="top-center"  autoClose={3000}  hideProgressBar={false}  newestOnTop={false}  closeOnClick  rtl={false}  pauseOnFocusLoss  draggable  pauseOnHover  theme={'colored'}/>
          {/* New User Registration */}
          <div className="section">
            <div className="row">
              <div className="col-md-12">
                <div className="section-title">
                  <h5><BiCategory className="me-1" />All brand category mapping</h5>
                </div>
                <div className="card p-2 mt-3">
                  <div className="card-title d-flex align-items-center justify-content-between flex-wrap gap-2">      
                    <div className="d-flex align-items-center gap-2">
                      <h5 className="mb-0">You have {totalItems} Brand Maps</h5>            
                      <Button onClick={()=> handleOpen()} className="badge btn-xs pt-1">Add New Brand Map</Button>
                    </div>
                    <div style={{ maxWidth: '300px', width: '100%' }}>
                      <input
                        type="text"
                        placeholder="Search by Brand, Category..."
                        value={searchText}
                        onChange={(e) => {
                          setSearchText(e.target.value);
                          setCurrentPage(1);
                        }}
                        className="form-control form-control-sm"
                        style={{ border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem' }}
                      />
                    </div>
                  </div>
                  <div>
                    <table className='table table-bordered'>
                        <thead>
                            <tr>
                                <th>SL</th>
                                <th>Brand</th>
                                <th>Category</th>
                                <th>Sub Category</th>
                                <th>Last Category</th>
                                <th className="text-center">Status</th>
                                <th className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                        {
                            paginatedBrandMaps && paginatedBrandMaps.length > 0 ? 
                            <>
                            { paginatedBrandMaps.map((item,index) => {
                                    return (
                                        <tr key={index}>
                                        <td>{(currentPage - 1) * itemsPerPage + index + 1}</td>
                                        <td>{item.brand}</td>
                                        <td>{item?.category || '-'}</td>
                                        <td>{item?.sub_category || '-'}</td>
                                        <td>{item?.last_category || '-'}</td>
                                        <td className="text-center">
                                            { item &&  item.status == 1 ?
                                            <Badge bg="success">Enable</Badge>:
                                            <Badge bg="danger">Disable</Badge>}
                                            </td>
                                        <td className="text-center">
                                          <button onClick={()=>editCall(item)} className='btn btn-xs btn-primary text-white'>Edit</button> &nbsp;
                                          {item && item.status == 1 ? 
                                            <button onClick={()=>handleStatus(item)} className='btn btn-xs btn-secondary text-white'>Make Disable</button>:
                                            <button onClick={()=>handleStatus(item)} className='btn btn-xs btn-success text-white'>Make Enable</button>} &nbsp;
                                          <button onClick={()=>handleDelete(item)} className='btn btn-xs btn-danger text-white'>Delete</button>
                                        </td>
                                    </tr>
                                    )
                                   }
                                )
                            }
                            </> 
                            : 
                            <><tr><td colSpan={7} className="text-center">No data found</td></tr></>
                        }
                               
                             
                        </tbody>
                    </table>

                    {/* Pagination Controls */}
                    {totalItems > 0 && (
                      <div className="flex items-center justify-between mt-4 px-2" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginTop: '1rem', padding: '0 0.5rem', flexWrap: 'wrap', gap: '0.75rem' }}>
                        <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>Show</span>
                          <select
                            value={itemsPerPage}
                            onChange={handleItemsPerPageChange}
                            className="px-2 py-1 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-black"
                            style={{ padding: '0.25rem 0.5rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', outline: 'none', background: '#fff' }}
                          >
                            <option value={5}>5</option>
                            <option value={10}>10</option>
                            <option value={25}>25</option>
                            <option value={50}>50</option>
                          </select>
                          <span className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>entries</span>
                        </div>

                        <div className="flex items-center gap-2" style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage - 1)}
                            disabled={currentPage === 1}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', padding: '0.25rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', fontWeight: 500, background: '#fff', color: '#000', opacity: currentPage === 1 ? 0.5 : 1, cursor: currentPage === 1 ? 'not-allowed' : 'pointer' }}
                          >
                            <ChevronLeft className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} /> Previous
                          </button>

                          <span className="text-sm font-medium px-2 text-gray-700" style={{ fontSize: '0.875rem', fontWeight: 500, padding: '0 0.5rem', color: '#374151' }}>
                            Page {currentPage} of {totalPages}
                          </span>

                          <button
                            type="button"
                            onClick={() => handlePageChange(currentPage + 1)}
                            disabled={currentPage === totalPages}
                            className="flex items-center gap-1 px-3 py-1 border border-gray-300 rounded-md text-sm disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100 transition-colors text-black font-medium"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '0.25rem', padding: '0.25rem 0.75rem', border: '1px solid #d1d5db', borderRadius: '0.375rem', fontSize: '0.875rem', fontWeight: 500, background: '#fff', color: '#000', opacity: currentPage === totalPages ? 0.5 : 1, cursor: currentPage === totalPages ? 'not-allowed' : 'pointer' }}
                          >
                            Next <ChevronRight className="h-4 w-4" style={{ height: '1rem', width: '1rem' }} />
                          </button>
                        </div>

                        <div className="text-sm text-gray-700" style={{ fontSize: '0.875rem', color: '#374151' }}>
                          Showing {totalItems === 0 ? 0 : ((currentPage - 1) * itemsPerPage) + 1} to {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems} entries
                        </div>
                      </div>
                    )}
                  </div>

                  {/* Add Cateory */}
                  <Modal size="md" show={show} onHide={handleClose}>
                      <Modal.Header className="py-1" closeButton>
                          <Modal.Title>Add Brand Map</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                          <Form>
                          {errors && errors ? <p style={{color : 'red' , fontSize : '12px'}}> {errors}</p> : ''}
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Select Cartegory name</Form.Label>
                            <Form.Select aria-label="Default select example" 
                              onChange = {e => handleCategory(e.target.value)}
                              value={selectedCategoryId}
                            >
                              <option value="">----select from below----</option>
                            {
                              category && category.length > 0 && category.map((item,index) => {
                                  return (
                                    <option key={index} value={item.id}> {item.name} </option>
                                  )
                              })
                            }
                            </Form.Select>
                          </Form.Group>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Select Sub Category</Form.Label>
                                <Form.Select aria-label="Default select example"
                                 onChange = {e => handleSubCategory(e.target.value)}
                                 value={selectedSubCategoryId}
                                 >
                                  <option value="">----select from below----</option>
                                  {subCategory && subCategory.length > 0 && subCategory.map((item,index) => {
                                      return <option key={index}  value={item.id}>{item.name}</option>
                                  })}
                                </Form.Select>
                          </Form.Group>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Select Last Category</Form.Label>
                            <Form.Select aria-label="Default select example" 
                            onChange={e => handleThirdCategory(e.target.value)}
                            value={selectedThirdCategoryId}
                            >
                              <option value="">---- select below -------</option>
                              {lastCategory && lastCategory.length > 0 && lastCategory.map((item,index) => {
                                return <option key={index}  value={item.id}>{item.name}</option>
                              })}
                            </Form.Select>
                          </Form.Group>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Select Brand</Form.Label>
                            <Form.Select aria-label="Default select example" 
                            onChange={e => setNewBrand({...newBrand, brand_id:e.target.value})}
                            value={newBrand?.brand_id || ''}
                            disabled={disabled} 
                            >
                              <option value="">---- select below -------</option>
                              {brandListfetch && brandListfetch.map((item,index) => {
                                return <option key={index}  value={item.id}>{item.name}</option>
                              })}
                            </Form.Select>
                          </Form.Group>
                          </Form>
                      </Modal.Body>
                      <Modal.Footer className="p-1 justify-content-start">
                          <button onClick={()=>handleClose()} className="btn btn-light btn-sm">
                              Close
                          </button>
                          <button onClick={()=>addBrandMap()} className="btn btn-primary btn-sm">
                              Save Changes
                          </button>
                      </Modal.Footer>
                  </Modal> 

                  {/* Status Toggle Modal */}
                  <Modal size="md" show={statusShow} onHide={handleStatusClose} centered>
                      <Modal.Header>
                          <Modal.Title className="h6 fw-bolder">Do you want to  {
                          newUpdateStatus && newUpdateStatus.status == 1 ?  'Disable' : 'Enable'
                        }</Modal.Title>
                      </Modal.Header>
                      <Modal.Footer className="p-1 justify-content-start">
                          <button onClick={()=>handleStatusClose()} className="btn btn-light btn-sm">
                              Close
                          </button>
                          <button onClick={()=>statusBrandMap()} className="btn btn-primary btn-sm">
                          {newUpdateStatus && newUpdateStatus.status == 1 ?  'Make Disable' : 'Make Enable'}
                          </button>
                      </Modal.Footer>
                  </Modal> 

                  {/* Delete Brand Map Modal */}
                  <Modal size="md" show={dshow} onHide={handleCloseDelete} centered>
                      <Modal.Header closeButton>
                          <Modal.Title className="h6 fw-bolder">Delete Brand Map</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                          Are you sure you want to delete brand map for <strong>{deleteItem?.brand}</strong> ({deleteItem?.last_category && deleteItem?.last_category !== '-' ? deleteItem?.last_category : (deleteItem?.sub_category && deleteItem?.sub_category !== '-' ? deleteItem?.sub_category : deleteItem?.category)})?
                      </Modal.Body>
                      <Modal.Footer className="p-2 justify-content-end">
                          <button onClick={handleCloseDelete} className="btn btn-light btn-sm">
                              Cancel
                          </button>
                          <button onClick={confirmDeleteBrandMap} className="btn btn-danger btn-sm">
                              Delete
                          </button>
                      </Modal.Footer>
                  </Modal> 

                  {/* Edit Category */}
                  <Modal size="md" show={Eshow} onHide={handleCloseEdit}>
                      <Modal.Header closeButton>
                          <Modal.Title>Edit Brand Map</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Select Cartegory name</Form.Label>
                            <Form.Select aria-label="Default select example" 
                              onChange = {e => {
                                  setEditBrand({...editBrand, category_id: e.target.value, sub_category_id: '', third_category_id: ''});
                                  setSubCategory([]);
                                  setLastCategory([]);
                                  getSubCategoryList(e.target.value);
                              }}
                              value={editBrand.category_id}
                            >
                              <option value="">----select from below----</option>
                            {
                              category && category.length > 0 && category.map((item,index) => {
                                  return (
                                    <option key={index} value={item.id}> {item.name} </option>
                                  )
                              })
                            }
                            </Form.Select>
                          </Form.Group>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                                <Form.Label>Select Sub Category</Form.Label>
                                <Form.Select aria-label="Default select example"
                                 onChange = {e => {
                                     setEditBrand({...editBrand, sub_category_id: e.target.value, third_category_id: ''});
                                     setLastCategory([]);
                                     getLastCategoryList(e.target.value);
                                 }}
                                 value={editBrand.sub_category_id}
                                 >
                                  <option value="">----select from below----</option>
                                  {subCategory && subCategory.length > 0 && subCategory.map((item,index) => {
                                      return <option key={index}  value={item.id}>{item.name}</option>
                                  })}
                                </Form.Select>
                          </Form.Group>
                      <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Select Third Category</Form.Label>
                            <Form.Select aria-label="Default select example" 
                            onChange={e => setEditBrand({...editBrand, third_category_id:e.target.value})}
                            value={editBrand.third_category_id}
                            >
                              <option value="">---- select below -------</option>
                              {lastCategory && lastCategory.length > 0 && lastCategory.map((item,index) => {
                                return <option key={index}  value={item.id}>{item.name}</option>
                              })}
                            </Form.Select>
                          </Form.Group>
                          <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>Select Brand</Form.Label>
                            <Form.Select aria-label="Default select example" 
                            onChange={e => setEditBrand({...editBrand, brand_id:e.target.value})}
                            value={editBrand.brand_id}
                            >
                              <option value="">---- select below -------</option>
                              {brandListfetch && brandListfetch.length > 0 && brandListfetch.map((item,index) => {
                                return <option key={index}  value={item.id}>{item.name}</option>
                              })}
                            </Form.Select>
                          </Form.Group>
                      </Modal.Body>
                      <Modal.Footer className="p-1 justify-content-start">
                          <button onClick={()=>handleCloseEdit()} className="btn btn-light btn-sm">
                              Close
                          </button>
                          <button onClick={()=>updateBrandMap()} className="btn btn-primary btn-sm">
                              Save Changes
                          </button>
                      </Modal.Footer>
                  </Modal> 

                </div>
              </div>
            </div>
          </div>
        </>
      }
    </div>
  );
}

export default BrandMap;
